// =============================================================================
// Pill / Badge / StatusDot components
// =============================================================================

import clsx from "clsx";

export type PillVariant = "active" | "pending" | "danger" | "accent" | "info" | "success" | "warning";

interface PillProps {
  children: React.ReactNode;
  variant?: PillVariant;
  className?: string;
}

export function Pill({ children, variant = "info", className }: PillProps) {
  const variantMap: Record<PillVariant, string> = {
    active: "pill-active",
    success: "pill-success",
    pending: "pill-pending",
    warning: "pill-warning",
    danger: "pill-danger",
    accent: "pill-accent",
    info: "pill-info",
  };

  return <span className={clsx(variantMap[variant], "shadow-sm", className)}>{children}</span>;
}

type StatusDotVariant = "active" | "warning" | "danger" | "info" | "accent" | "success";

interface StatusDotProps {
  variant?: StatusDotVariant;
  className?: string;
  label?: string;
}

export function StatusDot({ variant = "info", className, label }: StatusDotProps) {
  const variantMap: Record<StatusDotVariant, string> = {
    active: "status-dot-active",
    success: "status-dot-success",
    warning: "status-dot-warning",
    danger: "status-dot-danger",
    info: "status-dot-info",
    accent: "status-dot-accent",
  };

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={clsx("status-dot", variantMap[variant], className)} />
      {label && <span className="text-sm text-[var(--text-secondary)]">{label}</span>}
    </span>
  );
}

interface BadgeETAProps {
  minutes: number;
  className?: string;
}

export function BadgeETA({ minutes, className }: BadgeETAProps) {
  const text = minutes < 60 ? `${Math.round(minutes)} min` : `${Math.floor(minutes / 60)}h ${Math.round(minutes % 60)}m`;
  return <span className={clsx("badge-eta shadow-sm", className)}>🕐 {text}</span>;
}
